export default __webpack_public_path__ + "static/media/baby_jellyfish.75bb3cba.png";